import { render, staticRenderFns } from "./SiteAlertPreferences.vue?vue&type=template&id=a25e9b72&scoped=true&"
import script from "./SiteAlertPreferences.vue?vue&type=script&lang=js&"
export * from "./SiteAlertPreferences.vue?vue&type=script&lang=js&"
import style0 from "./SiteAlertPreferences.vue?vue&type=style&index=0&id=a25e9b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25e9b72",
  null
  
)

export default component.exports